import { render, staticRenderFns } from "./info.vue?vue&type=template&id=5b70ddbf&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=5b70ddbf&prod&lang=scss&scoped=true"
import style1 from "./info.vue?vue&type=style&index=1&id=5b70ddbf&prod&scoped=true&lang=css"
import style2 from "./info.vue?vue&type=style&index=2&id=5b70ddbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70ddbf",
  null
  
)

export default component.exports